module.exports = __webpack_public_path__ + "img/allottee5_7-8-2021.4e1736ca.jpg";